<template>
  <div
    v-if="address"
  >
    <v-widget
      :title="addressState"
    >
      <div slot="widget-header-action">
        <v-switch
          slot="activator"
          v-model="address.is_default"
          :label="$t('Default')"
          class="mt-4"
        />
      </div>
      <div slot="widget-content">
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            md12
          >
            <v-text-field
              v-model="address.address_line1"
              :error-messages="address.displayErrors('address_line1')"
              :label="$t('Street')"
              outline
            />
          </v-flex>
          <v-flex
            xs12
            md6
            class="pr-2"
          >
            <v-text-field
              v-model="address.locality"
              :error-messages="address.displayErrors('locality')"
              :label="$t('City')"
              outline
            />
            <country-select
              v-model="address.country_code"
              :error-messages="address.displayErrors('country_code')"
              :label="$t('Country')"
              outline
            />
            <region-select
              :country="address.country_code"
              v-model="address.administrative_area"
              :error-messages="address.displayErrors('administrative_area')"
              :label="$t('State')"
              outline
            />
            <v-text-field
              v-model="address.postal_code"
              :error-messages="address.displayErrors('postal_code')"
              :label="$t('Post code')"
              outline
            />
          </v-flex>
          <v-flex
            xs12
            md6
            class="pl-2"
          >
            <v-text-field
              v-model="address.given_name"
              :error-messages="address.displayErrors('given_name')"
              :label="$t('First Name')"
              outline
            />

            <v-text-field
              v-model="address.family_name"
              :error-messages="address.displayErrors('family_name')"
              :label="$t('Last Name')"
              outline
            />
            <v-text-field
              v-model="address.organization"
              :label="$t('Company')"
              class="pt-1"
              outline
            />
            <telephone-field
              v-model="address.telephone"
              outline
            />
          </v-flex>
        </v-layout>
      </div>
    </v-widget>
  </div>
</template>

<script>
import CountrySelect from '@/components/widgets/CountrySelect'
import RegionSelect from '@/components/widgets/RegionSelect'
import TelephoneField from '@/components/widgets/TelephoneField'

export default {
  name: 'CustomerAddressForm',

  components: {
    TelephoneField,
    RegionSelect,
    CountrySelect

  },
  props: {
    address: {
      type: Object,
      required: true
    }
  },

  computed: {
    addressState () {
      return `${this.address.locality}, ${this.address.administrative_area} ${this.address.postal_code}`
    }
  }
}
</script>
